'use client'

import { Box, Button, HStack } from '@chakra-ui/react'
import type { ShipperCategory } from '../utils'

import { ILocales } from '@/_service/shipper-category.service'
import {
  getShipperCategorySlug,
  matchesShipperCategory,
} from '@/_lib/filter-slugs'
import { Image, Text } from '@chakra-ui/react'
import { useLocale } from 'next-intl'
import { useQueryState } from 'nuqs'

type Props = {
  categories: ShipperCategory[]
}

const CategoryFiltersMobile: React.FC<Props> = ({ categories }) => {
  const [selectedCategory, setSelectedCategory] = useQueryState('category')
  const locale = useLocale() as ILocales

  const handleSelect = (category: ShipperCategory) => {
    const slug = getShipperCategorySlug(category)
    if (matchesShipperCategory(selectedCategory, category)) {
      setSelectedCategory(null)
    } else {
      setSelectedCategory(slug)
    }
  }

  return (
    <HStack
      flexWrap={{ base: 'nowrap' }}
      overflowX='auto'
      scrollbar='hidden'
      align='stretch'
      alignItems='flex-start'
      gap='3'
    >
      {categories?.map((category) => {
        const isActive = matchesShipperCategory(selectedCategory, category)
        return (
          <Button
            onClick={() => handleSelect(category)}
            key={category.id}
            variant='plain'
            display='flex'
            flexDirection='column'
            justifyContent='flex-start'
            alignItems='center'
            h='100%'
            p='0'
            gap='1'
          >
            <Box
              width='46px'
              height='46px'
              bg={category.image ? 'transparent' : 'gray.200'}
              rounded='lg'
              overflow='hidden'
              display='flex'
              alignItems='center'
              justifyContent='center'
            >
              {category.image ? (
                <Image
                  src={process.env.BASE_URL + category.image}
                  alt={category.name[locale]}
                  w='full'
                  h='full'
                  objectFit='contain'
                />
              ) : (
                <Text fontSize='md' fontWeight='semibold'>
                  {category.name[locale]}
                </Text>
              )}
            </Box>

            <Text
              lineClamp='2'
              wordBreak='normal'
              fontWeight={isActive ? 'bold' : 'normal'}
              fontSize='12px'
            >
              {category.name[locale]}
            </Text>
          </Button>
        )
      })}
    </HStack>
  )
}

export default CategoryFiltersMobile
